import React from 'react';
import { ElementWrapper } from '.';

export const Body = ({ element }) => {
    return <ElementWrapper element={element}></ElementWrapper>;
};
